import Vue from 'vue';
import Router from 'vue-router';
import store from '../store';
import paths from './paths';
import DEFINES from '@/defines';

Vue.use (Router);

const router = new Router ({
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return {x: 0, y: 0};
    }
  },
  mode: 'history',
  base: '/',
  linkActiveClass: 'active',
  routes: paths,
});

router.beforeEach (async (to, from, next) => {
  //which layout to use ?
  var oldLayout = store.getters['app/appLayout'];
  var newLayout = to.meta.layout || DEFINES.LAYOUT_GUEST;

  /**
   * 1. Change layout if navigating to different layout
   */
  if (newLayout != oldLayout) {
    store.dispatch (
      'app/setAppLayout',
      {
        layout: newLayout,
      },
      DEFINES.USE_ROOT
    );
  }

  next ();
});

export default router;
